import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SpinnerContext } from '@contexts';


interface SpinnerProviderProps {
    children: React.ReactNode
}

function SpinnerProvider({ children }: SpinnerProviderProps) {
    const [show, setSpinnerShow] = useState(false);
    const value = { show, setSpinnerShow };
    return <SpinnerContext.Provider value={value}>{children}</SpinnerContext.Provider>;
}

export default SpinnerProvider;

SpinnerProvider.propTypes = {
    children: PropTypes.node.isRequired
};
